const certificateTypes =
    {
        es: [
            {code:'ALL', name: 'Cualquier tipo'},
            {code:'mime', name: "Firma de documentos"},
            {code:'server', name: 'Servidor'},
            {code:'code', name: "Firma de código"},
            {code:'netcoca', name: "Netco CA"},
            {code:'ca', name: "CA"},
            {code:'timestamp', name: "Sello de Tiempo"}
        ],
        en: [
            {code:'ALL', name: 'Any Type'},
            {code:'mime', name: 'Document Signing'},
            {code:'server', name: 'Server'},
            {code:'code', name: "Code Signing"},
            {code:'netcoca', name: "Netco CA"},
            {code:'ca', name: "CA"},
            {code:'timestamp', name: "Timestamp"}
        ]
    }
export default certificateTypes;
